import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as MUI from '@mui/material';

import IconMenu from '@mui/icons-material/Menu';
import IconModeLight from '@mui/icons-material/LightMode';
import IconModeSystem from '@mui/icons-material/SettingsBrightness';
import IconModeDark from '@mui/icons-material/DarkModeOutlined';

export default function Toolbar(props) {
	const location = useLocation();
	const navigate = useNavigate();
	const [userMenu, setUserMenu] = useState(false);

	return (<MUI.Toolbar>
		<MUI.IconButton size="large" edge="start" color="inherit" aria-label="menu"
			sx={{ mr: 1, display: { xs: 'block', md: 'none' } }}
			onClick={() => navigate('?leftMenu', { state: location.state })}
		><IconMenu /></MUI.IconButton>
		<MUI.Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}>
		    Личный кабинет
		</MUI.Typography>
		<MUI.Box>
			<MUI.Tooltip title={props.account.name}>
				<MUI.IconButton color="inherit" sx={{ pr: 0 }} onClick={(e) => setUserMenu(e.currentTarget)}>
					<MUI.Avatar />
				</MUI.IconButton>
			</MUI.Tooltip>
			<MUI.Menu
				anchorEl={userMenu}
				open={userMenu !== false}
				onClose={() => setUserMenu(false)}
			>
				<MUI.Box sx={{ p: 1 }}>
					{props.account.name}
				</MUI.Box>
				<MUI.ButtonGroup variant="outlined" fullWidth={true} sx={{ px: 1, pb: 1 }}>
					<MUI.Tooltip title="Светлая тема">
						<MUI.Button
							variant={props.themeMode === 'light' ? "contained" : "outlined"}
							onClick={() => props.setThemeMode('light')}>
							<IconModeLight />
						</MUI.Button>
					</MUI.Tooltip>
					<MUI.Tooltip title="Автоопределение темы">
						<MUI.Button
							variant={props.themeMode === 'system' ? "contained" : "outlined"}
							onClick={() => props.setThemeMode('system')}>
							<IconModeSystem />
						</MUI.Button>
					</MUI.Tooltip>
					<MUI.Tooltip title="Темная тема">
						<MUI.Button
							variant={props.themeMode === 'dark' ? "contained" : "outlined"}
							onClick={() => props.setThemeMode('dark')}>
							<IconModeDark />
						</MUI.Button>
					</MUI.Tooltip>
				</MUI.ButtonGroup>
			</MUI.Menu>
		</MUI.Box>
	</MUI.Toolbar>)
}
